import { config } from '../app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
var AppConfigService = /** @class */ (function () {
    function AppConfigService(document) {
        this.document = document;
        this.config = config;
    }
    AppConfigService.prototype.getHostName = function () {
        var _a = this.document.location, hostname = _a.hostname, protocol = _a.protocol;
        return protocol + "//" + hostname;
    };
    AppConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppConfigService_Factory() { return new AppConfigService(i0.ɵɵinject(i1.DOCUMENT)); }, token: AppConfigService, providedIn: "root" });
    return AppConfigService;
}());
export { AppConfigService };
